module.exports = __webpack_public_path__ + "img/line-go.49fb36e7.png";